module.exports = __webpack_public_path__ + "platform/static/media/pending.4eaf62b2.svg";